module.exports = __webpack_public_path__ + "static/media/intro_vid.867c2f2d.mp4";